import { useCallback, useEffect, useState } from "react";
import { getServiceCatalogue, getPublicService } from "lib/siteServicesApi";
export function useServices(value, detail = false) {
  const [state, setState] = useState({ loading: true });
  const [request, setRequest] = useState(0);
  const retry = useCallback(() => setRequest(current => current + 1), []);
  useEffect(() => {
    const controller = new AbortController();
    setState({ loading: true });
    (detail
      ? getPublicService(value, controller.signal)
      : getServiceCatalogue(value, controller.signal)
    )
      .then((data) => {
        if (!controller.signal.aborted) setState({ key: value, detail, request, data });
      })
      .catch((error) => {
        if (!controller.signal.aborted) setState({ key: value, detail, request, error });
      });
    return () => controller.abort();
  }, [value, detail, request]);
  return { ...(state.key === value && state.detail === detail && state.request === request ? state : { loading: true }), retry };
}
